import { DataGrid } from "@msuite/ui/data-grid";
import { Link } from "@msuite/ui/link";
import { getAtomicNumberString } from "@msuite/utils/organizations";
import { guardString } from "@msuite/utils/strings";
import React from "react";
import { useService } from "@/hooks/use-service";
import type { ServicePanelBaseProps } from "../shared";

export function ServiceHierachyRow({ serviceId }: Pick<ServicePanelBaseProps, "serviceId">) {
	/** Hooks */
	const { service } = useService(serviceId);

	/** Guard */
	if (!service) return null;

	return (
		<React.Fragment>
			{service.parentServiceId && <ServiceHierachyRow serviceId={service.parentServiceId} />}
			<DataGrid.Row>
				<DataGrid.Label>{getAtomicNumberString(service.fullNumber)}</DataGrid.Label>
				<DataGrid.Value>
					<Link
						href={`/organization/data/services/${service.id}`}
						isExternal
					>
						{guardString(service.shortText)}
					</Link>
				</DataGrid.Value>
			</DataGrid.Row>
		</React.Fragment>
	);
}
